// TODO(tailwind) - deprecate MarginProps
export const marginKeys = ['m', 'mt', 'mb', 'ml', 'mr', 'mx', 'my'];
